import { render } from "./product_entries.vue?vue&type=template&id=b7ddeb72&scoped=true"
import script from "./product_entries.vue?vue&type=script&lang=js"
export * from "./product_entries.vue?vue&type=script&lang=js"

import "./product_entries.vue?vue&type=style&index=0&id=b7ddeb72&scoped=true&lang=css"
import "./product_entries.vue?vue&type=style&index=1&id=b7ddeb72&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ddeb72"]])

export default __exports__